import { useEffect, useState } from 'react'
import { api } from './api'

/** GET `path` now and every `ms` while the tab is visible; `null` path disables. Keeps the last good value on errors. */
export function usePolled<T>(path: string | null, ms: number): T | undefined {
  const [data, setData] = useState<T | undefined>(undefined)
  useEffect(() => {
    if (!path) return
    let alive = true
    const load = () => { if (document.visibilityState === 'visible') api<T>(path).then(d => { if (alive) setData(d) }).catch(() => undefined) }
    load()
    const t = setInterval(load, ms)
    document.addEventListener('visibilitychange', load)
    return () => { alive = false; clearInterval(t); document.removeEventListener('visibilitychange', load) }
  }, [path, ms])
  return data
}
